// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid black;
}

/* Main Container Section */
.descirption-container{
  width: 100%;
  border: 1px solid black;
  background-color: white;
  padding: 10px;
}

.c-container{
  display: flex;
  margin: 0 2rem;

  
}
.control-panel-section{
  width: 1000px;
  min-width: 750px;
  /* border: 1px solid black; */
}

.graph-container{
  display: flex;
  flex-direction: column;
}


.condition-control-panel-container{
  width: 100%;
  min-width: -moz-fit-content;
  min-width: fit-content;
  height: 80px;
  background-color: white;
  display: flex;

  box-sizing: border-box;
  align-items: center;
  box-shadow: 2px 2px 5px rgba(235, 233, 233, 0.3);
  margin: 10px 2rem;
  
}

.option-container{
  display: flex;
  flex-direction: column;
  height: -moz-fit-content;
  height: fit-content;
  padding-bottom: 10px;
}

.option-container div{
  min-width: 150px;
  font-size: 1.2rem;
  font-weight: bolder;
  margin-bottom: 5px;
}

.condition-selet-box{
  min-width: 100px;
  border: none;
  border-bottom: 1px solid black;
}


.option{
  height: 30px;
  margin: 3px;
  font-size: 0.8rem;
  font-weight: bolder;
  /* border-bottom: 1px solid black; */
  border-radius: 5px;

}

.select-option-container{
  display: flex;
}


.network-control-panel-container {
  padding: 15px;
  padding-top: 1rem;
  min-width: 750px;

  height: 1150px;
  display: flex;
  flex-direction: column;

  align-items: center;
  background-color: white;
}

.layer-input-container {
  min-width: 100px;
  display: flex;
}

.layer-container {
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgba(59, 59, 59, 0.137);
  box-shadow: 1px 2px grey;
  padding: 5px;
  margin: 5px;
}

.weight-container{
  display: flex;
}

.weight-input{
  margin: 5px;
  
}

.math-network-graph{
  width: 100px;
  min-width: 1000px;
  height: 500px;
  background-color: white;
}



.network-graph{
  width: 100px;
  min-width: 1020px;
  height: 500px;
  background-color: white;
}
/* Label */
.network-label-container{
  display: flex;
}

.x-label, .y-label {
  background-color: white;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  font-weight: bolder;
  font-size: 20px;
  
}



.function-graphic {
  width: 1000px;
  min-width: 1000px;
  height: 500px;
  background-color: white;
}

.weights-bias-container{
  display: flex;
}



.control-input-container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 3px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ch3/NeuralNetwork.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;;;AAGhB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,WAAW;EACX,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,aAAa;;EAEb,sBAAsB;EACtB,mBAAmB;EACnB,gDAAgD;EAChD,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAmB;EAAnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;;EAEhB,cAAc;EACd,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;;AAEb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;;;AAIA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;AACA,UAAU;AACV;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB,EAAE,SAAS;EAC9B,uBAAuB,EAAE,SAAS;EAClC,mBAAmB;EACnB,eAAe;;AAEjB;;;;AAIA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd","sourcesContent":["input {\n  box-sizing: border-box;\n  border: none;\n  border-bottom: 1px solid black;\n}\n\n/* Main Container Section */\n.descirption-container{\n  width: 100%;\n  border: 1px solid black;\n  background-color: white;\n  padding: 10px;\n}\n\n.c-container{\n  display: flex;\n  margin: 0 2rem;\n\n  \n}\n.control-panel-section{\n  width: 1000px;\n  min-width: 750px;\n  /* border: 1px solid black; */\n}\n\n.graph-container{\n  display: flex;\n  flex-direction: column;\n}\n\n\n.condition-control-panel-container{\n  width: 100%;\n  min-width: fit-content;\n  height: 80px;\n  background-color: white;\n  display: flex;\n\n  box-sizing: border-box;\n  align-items: center;\n  box-shadow: 2px 2px 5px rgba(235, 233, 233, 0.3);\n  margin: 10px 2rem;\n  \n}\n\n.option-container{\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n  padding-bottom: 10px;\n}\n\n.option-container div{\n  min-width: 150px;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  margin-bottom: 5px;\n}\n\n.condition-selet-box{\n  min-width: 100px;\n  border: none;\n  border-bottom: 1px solid black;\n}\n\n\n.option{\n  height: 30px;\n  margin: 3px;\n  font-size: 0.8rem;\n  font-weight: bolder;\n  /* border-bottom: 1px solid black; */\n  border-radius: 5px;\n\n}\n\n.select-option-container{\n  display: flex;\n}\n\n\n.network-control-panel-container {\n  padding: 15px;\n  padding-top: 1rem;\n  min-width: 750px;\n\n  height: 1150px;\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n  background-color: white;\n}\n\n.layer-input-container {\n  min-width: 100px;\n  display: flex;\n}\n\n.layer-container {\n  width: fit-content;\n  background-color: rgba(59, 59, 59, 0.137);\n  box-shadow: 1px 2px grey;\n  padding: 5px;\n  margin: 5px;\n}\n\n.weight-container{\n  display: flex;\n}\n\n.weight-input{\n  margin: 5px;\n  \n}\n\n.math-network-graph{\n  width: 100px;\n  min-width: 1000px;\n  height: 500px;\n  background-color: white;\n}\n\n\n\n.network-graph{\n  width: 100px;\n  min-width: 1020px;\n  height: 500px;\n  background-color: white;\n}\n/* Label */\n.network-label-container{\n  display: flex;\n}\n\n.x-label, .y-label {\n  background-color: white;\n  display: flex;\n  align-items: center; /* 垂直居中 */\n  justify-content: center; /* 水平居中 */\n  font-weight: bolder;\n  font-size: 20px;\n  \n}\n\n\n\n.function-graphic {\n  width: 1000px;\n  min-width: 1000px;\n  height: 500px;\n  background-color: white;\n}\n\n.weights-bias-container{\n  display: flex;\n}\n\n\n\n.control-input-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
